const syncCaratorySizeValue = (listbox, value) => {
  const targetId = listbox?.dataset.selectedTarget;
  const target = targetId ? document.getElementById(targetId) : null;

  if (target && value !== undefined && value !== null && value !== "") {
    target.textContent = value;
  }
};

const revealSelectedCaratorySize = (popover) => {
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      const listbox = popover.querySelector("x-listbox[data-selected-target]");
      const selectedOption = listbox?.querySelector('[role="option"][aria-selected="true"]');

      if (!listbox || !selectedOption) {
        return;
      }

      const centerInside = (container) => {
        if (!container) {
          return;
        }

        const containerRect = container.getBoundingClientRect();
        const optionRect = selectedOption.getBoundingClientRect();
        const offset = optionRect.top - containerRect.top - (containerRect.height - optionRect.height) / 2;

        container.scrollTop += offset;
      };

      centerInside(listbox);

      requestAnimationFrame(() => {
        centerInside(popover.shadowRoot?.querySelector('[part="content"]'));
      });
    });
  });
};

const initializeCaratorySizePopover = (popover) => {
  if (popover.dataset.caratorySizeInitialized === "true") {
    return;
  }

  popover.dataset.caratorySizeInitialized = "true";
  popover.addEventListener("dialog:after-show", () => revealSelectedCaratorySize(popover));
  popover.addEventListener("toggle", () => {
    if (popover.hasAttribute("open")) {
      window.setTimeout(() => revealSelectedCaratorySize(popover), 250);
    }
  });
};

const initializeCaratorySizePopovers = (root = document) => {
  if (root.matches?.("x-popover.caratory-size-dropdown__popover")) {
    initializeCaratorySizePopover(root);
  }

  root.querySelectorAll?.("x-popover.caratory-size-dropdown__popover").forEach(initializeCaratorySizePopover);
};

initializeCaratorySizePopovers();

new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      if (node instanceof Element) {
        initializeCaratorySizePopovers(node);
      }
    });
  });
}).observe(document.documentElement, { childList: true, subtree: true });

document.addEventListener("listbox:change", (event) => {
  const listbox = event.target.closest("x-listbox[data-selected-target]");

  if (listbox) {
    syncCaratorySizeValue(listbox, event.detail?.value);
  }
});

document.addEventListener("variant:change", (event) => {
  document.querySelectorAll("x-listbox[data-selected-target]").forEach((listbox) => {
    const hiddenInput = listbox.querySelector('input[type="hidden"][name^="option"]');

    if (!hiddenInput) {
      return;
    }

    const optionIndex = Number(hiddenInput.name.replace("option", "")) - 1;
    const selectedValue = event.detail?.variant?.options?.[optionIndex];

    syncCaratorySizeValue(listbox, selectedValue || hiddenInput.value);
  });
});
